import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  IAppErrorFactory,
  IUsersService,
  IUserAttachmentBase,
  IUseCaseOutputFactory,
  IUpdateUserAttachmentUseCase,
  UpdateUserAttachmentUseCaseInput,
  UpdateUserAttachmentUseCaseOutput,
} from '../../types'

@injectable()
export default class UpdateUserAttachmentInteractor implements IUpdateUserAttachmentUseCase {
  @inject(symbols.IUsersService) private usersService: IUsersService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    userAttachment: null | IUserAttachmentBase
  }>

  async handle(input: UpdateUserAttachmentUseCaseInput): Promise<UpdateUserAttachmentUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        userAttachment: null,
      },
    })
    try {
      output.data.userAttachment = await this.usersService.updateUserAttachment(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
